const baseUrl = process.env.REACT_APP_API_ENDPOINT;

if (!baseUrl) {
    throw new Error('REACT_APP_API_ENDPOINT is not set. All environments must define this variable.');
}

export default `${baseUrl}/api`;
